import React from "react";
import { useNavigate } from "react-router-dom";
import "./ChooseTest.css";
import search from "../../../assets/search.png";

const ChooseTest: React.FC = () => {
  const navigate = useNavigate();

  const handleStartTest = () => {
    navigate("/test-info");
  };

  return (
    <div role="main">
      <div className="title"></div>
      <div className="title22">
        <div>Система проведения аккредитации специалистов</div>
        <div className="imgCont">
          <img src={search} alt="" style={{ width: 20 }} />
        </div>
      </div>
      <div className="content-test">
        <div
          onClick={() => {
            localStorage.clear();

            navigate("/");
          }}
          className="gohome"
        >
          Выход
        </div>
        <div className="container">
          <p className="test-name" onClick={handleStartTest}>
            [1] Тестирование - 1 -й этап
          </p>
        </div>
        <div className="btn-cont">
          <button className="button">Все курсы</button>
        </div>
      </div>
    </div>
  );
};

export default ChooseTest;
